import { render, staticRenderFns } from "./LandingStepPoint.vue?vue&type=template&id=70b251c6&"
import script from "./LandingStepPoint.vue?vue&type=script&lang=js&"
export * from "./LandingStepPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports